// Подменяем public_path__ webpack'a в runtime
/* eslint-disable */
__webpack_public_path__ = window.CONFIG.staticPath;
